import { CanActivateFn, Router } from '@angular/router';
import { Usuario } from '../../main/objetos/usuario';
import { showBasicAlert } from '../../../shared/tools/swal-alerts';
import { DocumentosService } from '../services/documentos.service';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../../auth/services/auth.service';

export const ValidarEmpresasGuard: CanActivateFn = async () => {
  const documentosService = inject(DocumentosService);
  const authService = inject(AuthService);
  const router = inject(Router);
  const usuario: Usuario = JSON.parse(localStorage.getItem('user') || '');

  try {
    const response = await firstValueFrom(
      documentosService.obtenerEmpresasPorUsuario(usuario.id ?? 0)
    );
    const numeroEmpresas = response.payload.asignadas.length;

    if (numeroEmpresas === 0) {
      showBasicAlert('Error', 'No tienes empresas asignadas', 'error');
      return false;
    }

    if (numeroEmpresas > 1) {
      showBasicAlert(
        'Error',
        'No puedes acceder al punto de venta con múltiples empresas asignadas. Favor de contactar a soporte.',
        'error'
      );
      return false;
    }

    return true;
  } catch (error: unknown) {
    // Detectar HttpErrorResponse con status 401
    if (error instanceof HttpErrorResponse && error.status === 401) {
      if (localStorage.getItem('token')) {
        authService.logout();
      }
      router.navigateByUrl('/auth/login');
      return false;
    }

    // Detectar EmptyError (cuando el interceptor retorna EMPTY por un 401)
    const errorAny = error as any;
    if (
      errorAny?.name === 'EmptyError' ||
      (errorAny?.message &&
        errorAny.message.includes('no elements in sequence'))
    ) {
      if (localStorage.getItem('token')) {
        authService.logout();
      }
      router.navigateByUrl('/auth/login');
      return false;
    }

    // Manejar otros errores
    const errorMessage = 'Error al validar empresas';
    showBasicAlert('Error', errorMessage, 'error');
    return false;
  }
};
